/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ofType, StateObservable } from 'redux-observable';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { Action, ActionCreators } from './actions';
import { RootState } from '../index';
import { handleErrorInterceptor } from '../../utils/AuthUtils';

// Request Coverage
const requestCoverageSuccess = (response: AjaxResponse<any>) => {
  return ActionCreators.ReceivedGroundStationCoverageSuccess.create(response);
};

const requestCoverageError = (error: AjaxError) => {
  return ActionCreators.ReceivedGroundStationCoverageError.create(error);
};

export const requestCoverageEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>,
  { ajaxRaw }: any,
): Observable<Action> =>
  action$.pipe(
    ofType(ActionCreators.RequestGroundStationCoverage.type),
    switchMap(
      ($action: any): Observable<Action> =>
        ajaxRaw.get('/groundStations/coverage').pipe(
          map((response: AjaxResponse<any>) => requestCoverageSuccess(response)),
          catchError(
            (error: AjaxError): Observable<Action> => handleErrorInterceptor(error, of(requestCoverageError(error))),
          ),
        ),
    ),
  );